import { SortDirection } from '../../types/subscription';

/**
 * Next sort state after clicking a header: the same column flips direction, a new column starts with
 * `defaultDirection` (text columns read best A→Z, dates and numbers newest/largest first).
 */
export const nextSort = <S extends string>(
  current: { sort: S; direction: SortDirection },
  column: S,
  defaultDirection: SortDirection,
): { sort: S; direction: SortDirection } =>
  current.sort === column
    ? { sort: column, direction: current.direction === 'ASC' ? 'DESC' : 'ASC' }
    : { sort: column, direction: defaultDirection };
